module.exports = __webpack_public_path__ + "models/scene3.7056451.atlas";